import { DropdownOption } from "src/models/layout.models";

import { CONSTANTS } from "../constants";

import "react-toastify/dist/ReactToastify.css";

const clearLocalStorage = () => {
  localStorage.clear();
};

const getApiHeader = async () => {
  const accessToken: string | null = getLocalStorage(
    CONSTANTS.LOCAL_STORAGE.ACCESS_TOKEN
  );

  const head: Record<string, string> = {
    Accept: "*/*",
  };

  if (accessToken) {
    head["Authorization"] = "Bearer " + accessToken;
  }

  return head;
};

const getDropdownOptions = (
  data: { id: string | number; name: string }[]
): DropdownOption[] => {
  const options: DropdownOption[] = [];
  data?.forEach(item => {
    const option: DropdownOption = {
      label: item.name,
      value: item.id,
    };
    options.push(option);
  });

  return options;
};

const getLocalStorage = (key: string, type?: string) => {
  if (type && type === CONSTANTS.LOCAL_TYPE.LOCAL_STORAGE)
    return JSON.parse(localStorage.getItem(key) ?? "{}");
  return localStorage.getItem(key);
};

const setLocalStorage = <T>(items: Record<string, T>, type?: string) => {
  Object.keys(items).forEach(key => {
    let data: T | string = items[key];
    if (type && type === CONSTANTS.LOCAL_TYPE.LOCAL_STORAGE)
      data = JSON.stringify(items[key]);
    localStorage.setItem(key, String(data));
  });
};

const commonService = {
  clearLocalStorage,
  getApiHeader,
  getDropdownOptions,
  getLocalStorage,
  setLocalStorage,
};

export default commonService;
